import { Button, Input } from '@heroui/react'
import React, { useEffect, useState } from 'react'
import { EditProfileIcon, UpdateProfileIcon } from '../utils/svgIcons'
import { Skeleton, useDisclosure } from "@heroui/react";
import { useAuth } from '../hooks/useAuth';
import toast, { Toaster } from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import * as authAction from '../redux/actions/authAction';
import { bindActionCreators } from '@reduxjs/toolkit';
import { isValidEmailAddress, validateRequiredFields } from '../utils/Validation';
import ModalBox from '../components/PopupModals/Modal';


function EditProfile() {
  const { user, loading } = useAuth(); // Fetch user details
  const dispatch = useDispatch();
  const { updateAdmin, loadUser } = bindActionCreators(authAction, dispatch);
  const [formData, setFormData] = useState({ name: '', email: '' });
  const [isEditing, setIsEditing] = useState(false);
  const [isEditingLoading, setIsEditingloading] = useState(false);
  const [isclicked, setIsclicked] = useState(false)
  const [errors, setErrors] = useState({});

  // Dynamic Modal
  const { isOpen, onOpen, onClose } = useDisclosure();
  // Modal End

  // Load user data into form
  useEffect(() => {
    if (user) {
      setFormData({ name: user?.name || '', email: user?.email || '' });
    }
  }, [user]);

  useEffect(() => {
    const allErrors = validateRequiredFields(formData, ["name", "email"])
    if (formData.email && !isValidEmailAddress(formData.email)) {
      allErrors.email = "Please enter a valid email.";
    }
    setErrors(allErrors)
  }, [formData])

  // Handle Input Change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    })
    setIsEditing(true);
  };


  // Edittoggle 
  const handleEditToggle = () => {
    setIsEditing(true);
    setIsclicked(false);
  }

  // Handle Update Click
  const handleUpdate = () => {
    const isAnyFieldEmpty = Object.values(formData).some(value => value === "");

    if (formData.name.trim() === user.name.trim()) {
      toast.error("No changes detected. Please update your name before saving.");
      setTimeout(() => {
        setIsclicked(false)
      }, 2000);
      return;
    }

    if (Object.keys(errors).length !== 0) {
      setIsclicked(false);
    }

    else if (isAnyFieldEmpty) {
      toast.error("All the fields are mandatory.");
      setTimeout(() => {
        setIsclicked(false)
      }, 3000);
    }

    else if (Object.keys(errors).length === 0) {
      setIsclicked(false);
      onOpen();
    }

    else {
      setTimeout(() => {
        setIsclicked(false)
      }, 3000)
    }
  };

  const handleConfirmUpdate = () => {
    setIsEditingloading(true);

    onClose(onClose);

    updateAdmin(user._id, formData)
      .then((res) => {
        toast.success(res.data.message);
        setIsEditingloading(false)
        setIsEditing(false);
        setIsclicked(false);
        onClose(onClose);
        loadUser();
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        setIsclicked(false);
        setIsEditingloading(false);
        loadUser();
        setIsEditing(false);
      });
  }
  return (
    <div className='flex flex-col'>
      <div className='flex flex-row justify-between items-center px-4 border-b py-4 border-gray-100'>
        <h3 className='text-lg font-medium'>Personal Details</h3>

        <Button
          key="blur"
          className="bg-button text-white"
          isDisabled={Object.keys(errors).length !== 0}
          startContent={isEditing ? < UpdateProfileIcon /> : <EditProfileIcon />}
          onPress={isEditing ? handleUpdate : () => handleEditToggle()}
        >
          {isEditing ? (isclicked ? 'Updating...' : 'Update') : 'Edit'}
        </Button>
      </div>
      {loading || isEditingLoading ? (
        <div className="w-full flex gap-2 p-4">
          <Skeleton className="w-full h-14 rounded-lg" />
          <Skeleton className="w-full h-14 rounded-lg" />
        </div>
      ) : (
        <div className="flex w-full flex-wrap md:flex-nowrap gap-4 p-4">
          <Input
            label="Name"
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            isDisabled={!isEditing}
            isRequired
            isInvalid={errors.name ? true : false}
            errorMessage={errors.name && errors.name.message}
          />
          <Input
            label="Email"
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            isDisabled={true}
            isRequired
            isInvalid={errors.email ? true : false}
            errorMessage={errors.email && errors.email.message || errors.email}
          />
        </div>
      )}
      <Toaster position="top-right" reverseOrder={false} />
      <ModalBox
        title={'Confirm Profile Change'}
        isOpen={isOpen}
        onOpen={onOpen}
        onClose={onClose}
        handleConfirmUpdate={handleConfirmUpdate}
      >
        <div className="flex flex-col">
          <p>Are you sure!</p>
          <p>You want to <span className="text-amber-600 font-semibold">update your profile?</span></p>
        </div>
      </ModalBox>
    </div>
  )
}

export default EditProfile